import React, { useState } from 'react';
import { addReaction, removeReaction } from '../api/feedApi';
import useAuthStore from '../../stores/authStore';
import './ReactionButtons.css';

const ReactionButtons = ({ postId, initialLikes, initialDislikes, initialUserReaction, onUpdate }) => {
  const [likesCount, setLikesCount] = useState(initialLikes);
  const [dislikesCount, setDislikesCount] = useState(initialDislikes);
  const [userReaction, setUserReaction] = useState(initialUserReaction);
  const [loading, setLoading] = useState(false);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  const handleReaction = async (reactionType) => {
    if (!isAuthenticated) {
      alert('Please sign in to react to posts');
      return;
    }

    if (loading) return;

    setLoading(true);

    try {
      // Optimistic update
      const prevUserReaction = userReaction;

      if (userReaction === reactionType) {
        // Remove reaction
        setUserReaction(null);
        if (reactionType === 'like') {
          setLikesCount(prev => prev - 1);
        } else {
          setDislikesCount(prev => prev - 1);
        }
        await removeReaction(postId);
      } else {
        // Add or change reaction
        if (prevUserReaction === 'like') {
          setLikesCount(prev => prev - 1);
        } else if (prevUserReaction === 'dislike') {
          setDislikesCount(prev => prev - 1);
        }

        setUserReaction(reactionType);
        if (reactionType === 'like') {
          setLikesCount(prev => prev + 1);
        } else {
          setDislikesCount(prev => prev + 1);
        }

        const response = await addReaction(postId, reactionType);
        
        // Update with server response
        if (response.success && response.data) {
          setLikesCount(response.data.likesCount);
          setDislikesCount(response.data.dislikesCount);
          setUserReaction(response.data.userReaction);
        }
      }

      if (onUpdate) {
        onUpdate({ likesCount, dislikesCount, userReaction });
      }
    } catch (error) {
      console.error('Error updating reaction:', error);
      alert(error.message || 'Failed to update reaction');
      // Revert on error
      setUserReaction(userReaction);
      setLikesCount(initialLikes);
      setDislikesCount(initialDislikes);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reaction-buttons">
      <button
        className={`reaction-btn like-btn ${userReaction === 'like' ? 'active' : ''}`}
        onClick={() => handleReaction('like')}
        disabled={loading}
        title="Like"
      >
        <span className="reaction-icon">👍</span>
        <span className="reaction-count">{likesCount}</span>
      </button>

      <button
        className={`reaction-btn dislike-btn ${userReaction === 'dislike' ? 'active' : ''}`}
        onClick={() => handleReaction('dislike')}
        disabled={loading}
        title="Dislike"
      >
        <span className="reaction-icon">👎</span>
        <span className="reaction-count">{dislikesCount}</span>
      </button>
    </div>
  );
};

export default ReactionButtons;
